import { render, staticRenderFns } from "./OrderSpreadsheetFormatsDetails.vue?vue&type=template&id=266206f8&"
import script from "./OrderSpreadsheetFormatsDetails.vue?vue&type=script&lang=js&"
export * from "./OrderSpreadsheetFormatsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports